import { Card, Link } from '@shopify/polaris';
import React from 'react';
import '../../css/recommendapp.css';
import { Row, Col } from 'reactstrap';
import { configRecommend } from './configRecommend';

const RecommendedApps = () => {
  return (
    <div className="recommended-app-wrapper">
      <Card sectioned title="Recommended apps">
        <Row>
          {configRecommend.map((item, index) => (
            <Col xs="12" sm="12" md="4" xl="3" className="d-flex" key={index}>
              <div className="recommended-layout">
                <a
                  href={item.href}
                  target="_blank"
                  style={{ cursor: 'pointer' }}
                  className="recommended-app-link"
                >
                  <div className="recommended-app">
                    <div className="recommended-app-grid">
                      <div>
                        <img
                          src={item.img}
                          width="100%"
                          style={{
                            borderRadius: '10px',
                          }}
                        />
                      </div>
                      <div className="recommended-app-content">
                        <b>{item.title}</b>
                        {item.brand !== '' ? (
                          <div className="brand">
                            by{' '}
                            <a href={item.brandURL} target="_blank">
                              {item.brand}
                            </a>
                          </div>
                        ) : null}
                        <p>{item.description}</p>
                        <div className="recommended-app-footer">
                          <div>
                            <span>
                              {item.star !== 0 ? (
                                <>
                                  <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 19 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M18.9498 7.32101C18.8901 7.14516 18.7802 6.99064 18.6336 6.87653C18.4871 6.76242 18.3103 6.69372 18.1252 6.6789L12.7092 6.24861L10.3655 1.06134C10.2909 0.894274 10.1695 0.752371 10.016 0.652764C9.86246 0.553156 9.6834 0.500101 9.50039 0.5C9.31738 0.4999 9.13826 0.552759 8.98463 0.652198C8.83101 0.751637 8.70945 0.893406 8.63463 1.0604L6.29096 6.24861L0.87498 6.6789C0.693012 6.69331 0.519049 6.75984 0.373904 6.87052C0.22876 6.9812 0.118579 7.13134 0.0565438 7.303C-0.0054914 7.47465 -0.0167542 7.66053 0.0241028 7.83841C0.0649598 8.0163 0.156207 8.17864 0.286927 8.30603L4.2893 12.2072L2.87379 18.3358C2.83081 18.5213 2.84459 18.7154 2.91333 18.893C2.98207 19.0706 3.10261 19.2234 3.25931 19.3316C3.416 19.4399 3.60161 19.4985 3.79205 19.5C3.98249 19.5014 4.16898 19.4456 4.3273 19.3398L9.50008 15.8917L14.6729 19.3398C14.8347 19.4472 15.0255 19.5025 15.2197 19.4982C15.4139 19.494 15.6021 19.4304 15.7591 19.316C15.916 19.2015 16.0342 19.0418 16.0976 18.8583C16.1611 18.6747 16.1668 18.4761 16.114 18.2892L14.3765 12.21L18.6857 8.33263C18.9678 8.07806 19.0714 7.68102 18.9498 7.32101Z"
                                      fill="#FFD233"
                                    />
                                  </svg>
                                  {item.star} {''}
                                </>
                              ) : (
                                ''
                              )}
                              {item.review ? `(${item.review} reviews) - ` : ''}{' '}
                              <i>{item.plan}</i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </Col>
          ))}
        </Row>
      </Card>
    </div>
  );
};

export default RecommendedApps;
